<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل مدير</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/managerview">مديرين الموقع</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل مدير</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="loader" class="text-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="me-2 text-brown">
              <i class="bi bi-pencil-square mx-2 text-brown"></i>تعديل مدير
            </h5>
            <div class="card">
              <div v-if="successfuly" class="pt-3 text-center">
                <successAlert :message= "message" />
              </div>
              <div class="card-body">
                <errorAlert v-if="adminError" :alertMessage= "message" />
                <div class="row">
                  <div class="col">
                    <ul class="nav nav-tabs p-0" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" href="#" data-bs-toggle="tab"
                          data-bs-target="#personalTab"
                          role="tab"
                        >بيانات الحساب</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" href="#" data-bs-toggle="tab"
                          data-bs-target="#devicesTab"
                          role="tab"
                        >الاجهزة</a>
                      </li>
                    </ul>
                    <div class="tab-content border p-3" id="myTabContent">
                      <div class="tab-pane fade show active" id="personalTab" role="tabpanel">
                        <form action="" @submit.prevent="adminUpdate">
                          <!-- Avatar -->
                          <div class="row py-2">
                            <div class="col text-center">
                              <label class="form-label d-block">الصورة الشخصية</label>
                              <div class="d-inline-block position-relative mb-2">
                                <img
                                  v-if="avatarPreview || (currentAvatar && !removeAvatar)"
                                  :src="avatarPreview || ($store.getters.MEDIA_URL + currentAvatar)"
                                  class="rounded-circle border border-2 border-primary"
                                  style="width:100px;height:100px;object-fit:cover;"
                                  alt="Avatar"
                                />
                                <div
                                  v-else
                                  class="rounded-circle border border-2 border-secondary d-flex align-items-center justify-content-center bg-light"
                                  style="width:100px;height:100px;"
                                >
                                  <i class="bi bi-person" style="font-size:48px;color:#aaa;"></i>
                                </div>
                                <label
                                  for="managerAvatarInput"
                                  class="position-absolute bottom-0 end-0 btn btn-primary btn-sm rounded-circle p-1"
                                  style="cursor:pointer;width:30px;height:30px;display:flex;align-items:center;justify-content:center;"
                                  title="تغيير الصورة"
                                >
                                  <i class="bi bi-camera-fill" style="font-size:13px;"></i>
                                </label>
                                <input
                                  type="file"
                                  id="managerAvatarInput"
                                  accept="image/*"
                                  class="d-none"
                                  @change="onAvatarChange"
                                />
                              </div>
                              <div>
                                <button
                                  v-if="(currentAvatar && !removeAvatar) || avatarPreview"
                                  type="button"
                                  class="btn btn-sm btn-outline-danger"
                                  @click="clearAvatar"
                                >
                                  <i class="bi bi-trash me-1"></i> إزالة الصورة
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="row py-2">
                            <div class="col">
                              <label for="">الاسم</label>
                              <input type="text" class="form-control" v-model="adminName">
                            </div>
                          </div>
                          <div class="row py-2">
                            <div class="col">
                              <label for="">البريد الإلكتروني</label>
                              <input type="email" class="form-control" v-model="email">
                            </div>
                          </div>
                          <div class="row py-2">
                            <div class="col">
                              <label for="">كلمة المرور</label>
                              <input type="password" class="form-control" v-model="password">
                            </div>
                          </div>
                          <div class="row py-2">
                            <div class="col">
                              <label for="">رقم الجوال <span v-if="isAccountManager" class="text-danger">*</span><span v-else>(اختياري)</span></label>
                              <input type="text" class="form-control" v-model="mobileNumber" :required="isAccountManager" placeholder="05xxxxxxxx">
                              <div v-if="isAccountManager" class="form-text">
                                رقم الجوال مطلوب لأن هذا الحساب مُفعّل كمدير حساب.
                              </div>
                            </div>
                          </div>
                          <div class="row py-2">
                            <div class="col">
                              <label for="">يمتلك جميع الصلاحيات (Super User)</label>
                              <select class="form-control" v-model="isAdmin">
                                <option :value="true">نعم</option>
                                <option :value="false">لا</option>
                              </select>
                            </div>
                          </div>
                          <div class="row py-2">
                            <div class="col">
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                  id="isAccountManagerUpdateCheck"
                                  v-model="isAccountManager"
                                />
                                <label class="form-check-label" for="isAccountManagerUpdateCheck">
                                  تفعيل هذا الحساب كمدير حساب أيضاً 
                                </label>
                                <div class="form-text">
                                  هذا الحساب سيبقى مديراً في اللوحة، وسيظهر أيضاً في قائمة مديرين الحسابات ليتم تعيينه للعملاء.
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row py-2">
                            <div class="col-md-6">
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                  id="isApprovalOfficerUpdateCheck"
                                  v-model="isApprovalOfficer"
                                />
                                <label class="form-check-label" for="isApprovalOfficerUpdateCheck">مسؤول تعميد</label>
                                <div class="form-text">يمكنه تعميد أو رفض الطلبات وإسنادها للموظفين التنفيذيين.</div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                  id="isExecutiveEmployeeUpdateCheck"
                                  v-model="isExecutiveEmployee"
                                />
                                <label class="form-check-label" for="isExecutiveEmployeeUpdateCheck">موظف تنفيذي</label>
                                <div class="form-text">يظهر في الإسناد لتنفيذ تركيب اللوحات وأعمال الصيانة والتسويق.</div>
                              </div>
                            </div>
                          </div>
                          <div class="row py-2">
                            <div class="col">
                              <label for="">المجموعات</label>
                              <select class="form-control" v-model="groups" multiple>
                                <option v-for="group in groupsList" :value="group.id" :key="group.id">{{ group.name }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="row py-2">
                            <div class="col">
                              <label for="">الحاله</label>
                              <select class="form-control" v-model="status">
                                <option :value="true">نشط</option>
                                <option :value="false">غير نشط</option>
                              </select>
                            </div>
                          </div>
                          <div class="row py-2">
                            <div class="col text-center">
                              <loader v-if="isLoading" />
                              <button v-else type="submit" class="btn btn-success">إرسال</button>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="tab-pane fade" id="devicesTab" role="tabpanel">
                        <div class="row">
                          <div class="col">
                            <div v-if="GET_USER_DATA.isSuperUser" class="table-responsive">
                              <table class="table table-striped text-center">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>اسم الجهاز</th>
                                    <th>مسموح به</th>
                                    <th>آخر تحديث</th>
                                    <th>العمليات</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(device, indx) in adminLoginDevices" :key="device.id">
                                    <td>{{ device.id }}</td>
                                    <td>
                                      <input type="hidden" name="id" :form="`form_${device.id}`" :value="device.id">
                                      <input type="text" name="name" :form="`form_${device.id}`" class="form-control" 
                                      :value="device.AdminDevice.name" placeholder="مثال: جهاز محمد خدمة العملاء ...">
                                    </td>
                                    <td>
                                      <select name="isAllowed" :form="`form_${device.id}`" class="form-control">
                                        <option :value="true" :selected="device.isAllowed">نعم</option>
                                        <option :value="false" :selected="!device.isAllowed">لا</option>
                                      </select>
                                    </td>
                                    <td>{{ $shortDate(device.updatedAt) }}</td>
                                    <td>
                                      <form :id="`form_${device.id}`" @submit.prevent="changeDeviceData">
                                        <input type="submit" class="btn btn-sm btn-warning" value="حفظ">
                                      </form>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div v-if="!GET_USER_DATA.isSuperUser" class="table-responsive">
                              <table class="table table-striped text-center">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>اسم الجهاز</th>
                                    <th>مسموح به</th>
                                    <th>آخر تحديث</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(device, indx) in adminLoginDevices" :key="device.id">
                                    <td>{{ device.id }}</td>
                                    <td>{{ device.AdminDevice.name   }}</td>
                                    <td>
                                      <span v-if="device.isAllowed" class="bg-success px-3 py-2 text-white">نعم</span>
                                      <span v-if="!device.isAllowed" class="bg-danger px-3 py-2 text-white">لا</span>
                                    </td>
                                    <td>{{ $shortDate(device.updatedAt) }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import { toast } from '@/helpers/tools';

export default {
  name:'managerupdate',
  computed: {
    ...mapGetters(['GET_USER_DATA']),
  },
  data(){
    return {
      Admin_Id: this.$route.params.id,
      loader: false,
      adminError: false,
      message: '',
      adminName: "",
      isLoading: false,
      status: true,
      successfuly: false,
      email: "",
      password: "",
      isAdmin: true,
      groups: [],
      groupsList: [],
      currentAvatar: null,
      avatarFile: null,
      avatarPreview: null,
      removeAvatar: false,
      mobileNumber: "",
      isAccountManager: false,
      isApprovalOfficer: false,
      isExecutiveEmployee: false,
      adminLoginDevices: [],
    }
  },
  methods:{
    getData() {
      this.loader = true;
      this.$http.get(`/api/admin/admins/retrieve/${this.Admin_Id}`).then(res => {
        // console.log(res);
        this.adminName = res.data.admin.name;
        this.status = res.data.admin.isActive;
        this.email = res.data.admin.email;
        this.isAdmin = res.data.admin.isSuperUser;
        this.currentAvatar = res.data.admin.avatar || null;
        this.groupsList = res.data.groups;
        this.mobileNumber = res.data.admin.mobileNumber || "";
        this.isAccountManager = !!res.data.admin.isAccountManager;
        this.isApprovalOfficer = !!res.data.admin.isApprovalOfficer;
        this.isExecutiveEmployee = !!res.data.admin.isExecutiveEmployee;
        this.adminLoginDevices = res.data.admin.AdminLoginDevices;
        if(res.data.admin.Groups){
          for(let i=0; i<res.data.admin.Groups.length; i++){
            this.groups.push(res.data.admin.Groups[i].id);
          }
        }
        this.loader = false;
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.adminError = true;
        this.loader = false;
        window.scroll(0,0);
      })
    },

    onAvatarChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.avatarFile = file;
      this.avatarPreview = URL.createObjectURL(file);
      this.removeAvatar = false;
    },
 
    clearAvatar() {
      this.avatarFile = null;
      this.avatarPreview = null;
      this.removeAvatar = true;
      const input = document.getElementById('managerAvatarInput');
      if (input) input.value = '';
    },

    adminUpdate(){
      this.successfuly = false;
      this.adminError = false;

      if (this.isAccountManager && !this.mobileNumber.trim()) {
        this.adminError = true;
        this.message = 'رقم الجوال مطلوب عند اختيار الحساب كمدير حساب';
        window.scroll(0,0);
        return;
      }

      this.isLoading = true;
      const formData = new FormData();
      formData.append('name', this.adminName);
      formData.append('email', this.email);
      formData.append('isActive', this.status);
      formData.append('isSuperUser', this.isAdmin);
      formData.append('groups', JSON.stringify(this.groups));
      formData.append('mobileNumber', this.mobileNumber || '');
      formData.append('isAccountManager', this.isAccountManager);
      formData.append('isApprovalOfficer', this.isApprovalOfficer);
      formData.append('isExecutiveEmployee', this.isExecutiveEmployee);
      if (this.password.trim() !== '') formData.append('password', this.password);
      if (this.removeAvatar) {
        formData.append('removeAvatar', 'true');
      } else if (this.avatarFile) {
        formData.append('avatar', this.avatarFile);
      }
 
      this.$http.put(`/api/admin/admins/update/${this.Admin_Id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then(res => {
        this.message = 'تم التعديل بنجاح';
        this.successfuly = true;
        this.isLoading = false;
        this.currentAvatar = res.data.admin.avatar || null;
        this.avatarFile = null;
        this.avatarPreview = null;
        this.removeAvatar = false;
        window.scroll(0, 0);
      }).catch(err => {
        this.message = this.$globalError(err);
        this.adminError = true;
        this.isLoading = false;
        window.scroll(0, 0);
      });
    },
    changeDeviceData(event){
      const formData = new FormData(event.target);
      const data = Object.fromEntries(formData.entries());
      if(data.name.trim() == ''){
        toast('يجب ادخال اسم الجهاز');
        return;
      }
      this.$http.post(`/api/admin/admins/updateDevice/${data.id}`, {
        name: data.name.trim(),
        isAllowed: data.isAllowed === 'true',
        adminId: parseInt(this.Admin_Id),
      }).then(({data}) => {
        toast('تم الحفظ بنجاح', 'success');
      }).catch(err => {
        const message = this.$globalError(err);
        toast(message);
      });
    },
  },
  created() {
    this.getData();
  }
}
</script>